"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var defaultStorageState = {
  deliveryConfirmation: true,
  channelsLastMsgId: {},
  channelsEncryptionKeys: {},
  isSessionDestroyed: false,
  isSessionRecovering: false,
  queryQueue: []
};
var STORAGE_PREFIX = 'soulStorage:';

var Storage =
/*#__PURE__*/
function () {
  function Storage() {
    var _this = this;

    _classCallCheck(this, Storage);

    this.storage = Object.assign({}, defaultStorageState); // - You can't win. It's pointless to keep fighting. Why, Mr. Anderson? Why? Why do you persist?

    this.persistentStorageExist = typeof window !== 'undefined' && !!window.localStorage;
    this.persistentFields = ['anonymous_user', 'sessionToken', 'accessToken', 'accessExpiresIn', 'refreshToken', 'refreshInProgress', 'deltaTime', 'userId', 'lastEventTime', 'phoneVerification', 'viewingSession', 'uniqueToken', 'phoneVerificationCode', 'email', 'emailVerificationCode', 'deviceId'];
    this.devFields = ['devMode', // Value for logging in browser console. Not specified by default
    'sessionRecoverDelay'];
    this.devFields.forEach(function (field) {
      return _this.persistentFields.push(field);
    }); // recover from persistent storage

    if (this.persistentStorageExist) {
      this.persistentFields.forEach(function (field) {
        return _this.storage[field] = window.localStorage.getItem(STORAGE_PREFIX + field);
      });
    }
  }

  _createClass(Storage, [{
    key: "saveSession",
    value: function saveSession(data) {
      this.storage.me = data.me;
      this.set('userId', data.me.id);
      this.storage.authenticated = true;

      if (data.authorization) {
        this.set('sessionToken', data.authorization.sessionToken);
      }
    }
  }, {
    key: "saveAuthorizationTokens",
    value: function saveAuthorizationTokens(authorization) {
      this.storage.authenticated = true;
      this.set('accessToken', authorization.access_token);
      this.set('accessExpiresIn', Date.now() + 1000 * authorization.expires_in);
      this.set('refreshToken', authorization.refresh_token);
      this.set('refreshExpiresIn', Date.now() + 1000 * authorization.refresh_expires_in);
    }
  }, {
    key: "setRefreshInProgress",
    value: function setRefreshInProgress(value) {
      this.set('refreshInProgress', value);
    }
    /*
      - What about the others?
      - ...What others?
      - The ones that want out.
      - Obviously they will be freed.
      - I have your word?
      - What do you think I am? Human?
    */

  }, {
    key: "removeSession",
    value: function removeSession() {
      var _this2 = this;

      var lastSessionToken = this.storage.sessionToken;
      var _this$storage = this.storage,
          apiKey = _this$storage.apiKey,
          userAgent = _this$storage.userAgent;
      this.storage = {
        channelsLastMsgId: {},
        channelsEncryptionKeys: {},
        apiKey: apiKey,
        userAgent: userAgent,
        lastSessionToken: lastSessionToken
      };
      this.persistentFields.filter(function (field) {
        return !_this2.devFields.includes(field);
      }).forEach(function (field) {
        return _this2.set(field, '');
      });
      this.persistentFields.forEach(function (key) {
        return _this2.set(key, '');
      });
    }
  }, {
    key: "get",
    value: function get(field) {
      if (Array.isArray(field)) {
        // get value from path ['a', 'b', 'c'] equal this.storage.a.b.c
        return field.reduce(function (acc, subField) {
          return acc && acc[subField] || null;
        }, this.storage);
      }

      return this.storage[field];
    }
  }, {
    key: "set",
    value: function set(field, value) {
      if (Array.isArray(field)) {
        // set value by path (['a', 'b', 'c'], val) equal this.storage.a.b.c = val
        var endParrent = field.slice(0, -1).reduce(function (acc, subField) {
          return acc && acc[subField] || null;
        }, this.storage);
        endParrent[field[field.length - 1]] = value;
        return;
      }

      if (this.persistentStorageExist && this.persistentFields.includes(field)) {
        window.localStorage.setItem(STORAGE_PREFIX + field, value);
      }

      this.storage[field] = value;
    }
  }]);

  return Storage;
}();

module.exports = Storage;